import type { EmailGiftCardProperties, GiftCard } from 'app/typings/giftCard';
import { format as formatDate, parse } from 'app/utils/dayjs';
import { capitalizeFirstLetter } from 'app/utils/string';

import { Line } from '../Line/Line';

type Props = {
  giftCard: GiftCard & EmailGiftCardProperties;
};

export const EmailProperties = ({ giftCard }: Props) => {
  const {
    giftCardType,
    color,
    emailSendDate,
    senderName,
    billingEmail,
    beneficiaryName,
    beneficiaryEmail,
    message,
  } = giftCard;

  return (
    <>
      <Line title="Type" value={capitalizeFirstLetter(giftCardType)} />
      <Line title="Color" value={capitalizeFirstLetter(color)} />
      <Line
        title="Send date"
        value={`${formatDate(
          parse(emailSendDate, 'YYYY-MM-DD', new Date()),
          'DD/MM/YYYY'
        )}`}
      />
      <Line title="Sender name" value={senderName} />
      <Line title="Sender email" value={billingEmail} />
      <Line title="Beneficiary name" value={beneficiaryName} />
      <Line title="Beneficiary email" value={beneficiaryEmail} />
      <Line title="Message" value={message} />
    </>
  );
};
